import script from "./MainProgress.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainProgress.vue?vue&type=script&lang=ts&setup=true"

import "./MainProgress.vue?vue&type=style&index=0&id=c7fb3830&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7fb3830"]])

export default __exports__